export default "__VITE_ASSET__BR3TcBSX__"